import { useChatContext } from './ChatContext';

const useStylePreview = () => {
    const { showStylePreview, setShowStylePreview } = useChatContext();
    return { showStylePreview, setShowStylePreview };
};

export default useStylePreview;
